import { render } from "./TopSavingsVouchersPage.vue?vue&type=template&id=1a93b7bf&scoped=true"
import script from "./TopSavingsVouchersPage.vue?vue&type=script&lang=js"
export * from "./TopSavingsVouchersPage.vue?vue&type=script&lang=js"

import "./TopSavingsVouchersPage.vue?vue&type=style&index=0&id=1a93b7bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a93b7bf"]])

export default __exports__